import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import StockManage from './stockManage';
import GoodsManage from './goodsManage';
import LiveManage from './liveManage';
import AreaManage from './areaManage'; // import OnlineShopCategoryManage from './categoryManage'

import OrderManage from './orderManage';
import SettingManage from './settingManage';
export default {
  name: 'OnlineShop',
  components: {
    GoodsManage: GoodsManage,
    StockManage: StockManage,
    LiveManage: LiveManage,
    // OnlineShopCategoryManage,
    AreaManage: AreaManage,
    OrderManage: OrderManage,
    SettingManage: SettingManage
  },
  data: function data() {
    return {
      activeName: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.params && _this.$route.params.activeName) {
                _this.activeName = _this.$route.params.activeName;
              } else {
                _this.activeName = 'StockManage';
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      this.activeName = tab.name;
    }
  }
};